import { RiveFile } from '@rive-app/canvas'
import rivReward from './reward.riv'

const riveFileReward = new RiveFile({ src: rivReward })

export const loadingRewardRive: Promise<RiveFile> = riveFileReward
  .init()
  .then(() => {
    riveFileReward.getInstance() // prevent from being cleaned up
    return riveFileReward
  })
